import {
    RESET_ALL_PROPERTY_OFFERS,
    RESET_ALL_ROOMTYPE_OFFERS,
    RESET_ALL_ROOMTYPE_OTA_COUNT,
    SAVE_ALL_PROPERTY_OFFERS,
    SAVE_ALL_ROOMTYPE_OFFERS,
    SAVE_ALL_ROOMTYPE_OTA_COUNT,
} from "../types";

const INITIAL_STATE = {
    offers: {
        list: [],
        showViewMore: false,
        pageNumber: 1,
        pageSize: 50,
    },
    propertyOffers: {
        list: [],
        showViewMore: false,
        pageNumber: 1,
        pageSize: 50,
    },
    otaCounts: {
        list: [],
        showViewMore: false,
        pageNumber: 1,
        pageSize: 10,
    },
};

const RoomtypesReducer = (state = INITIAL_STATE, { type, payload }) => {
    const currentState = {
        ...INITIAL_STATE,
        ...state,
        propertyOffers: state?.propertyOffers || INITIAL_STATE.propertyOffers,
    };
    switch (type) {
        case SAVE_ALL_ROOMTYPE_OFFERS:
            return {
                ...currentState,
                offers: {
                    pageSize: 10,
                    ...payload,
                },
            };

        case RESET_ALL_ROOMTYPE_OFFERS:
            return {
                ...currentState,
                offers: INITIAL_STATE.offers,
            };

        case SAVE_ALL_PROPERTY_OFFERS:
            return {
                ...currentState,
                propertyOffers: {
                    pageSize: 10,
                    ...payload,
                },
            };

        case RESET_ALL_PROPERTY_OFFERS:
            return {
                ...currentState,
                propertyOffers: INITIAL_STATE.propertyOffers,
            };

        case SAVE_ALL_ROOMTYPE_OTA_COUNT:
            return {
                ...currentState,
                otaCounts: {
                    pageSize: 10,
                    ...payload,
                },
            };

        case RESET_ALL_ROOMTYPE_OTA_COUNT:
            return {
                ...currentState,
                otaCounts: INITIAL_STATE.otaCounts,
            };

        default:
            return currentState;
    }
};

export default RoomtypesReducer;
